import { LOCALE_MAP } from '@/constants/locale';
export const setLang = (lang) => {
    const getHTMLTag = document.documentElement;
    getHTMLTag.setAttribute("lang", LOCALE_MAP[lang] ?? 'en-US');   
}